module.exports = __webpack_public_path__ + "img/News_item_10.dcc7f0fa.jpg";